<template>
  <v-card :loading="!!fetching">
    <v-card-title>
      Склад #{{model.id}}
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('dialog:close')">
        <v-icon color="error">mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <div>Название: {{model.name}}</div>
    </v-card-text>
  </v-card>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  const {mapState} = createNamespacedHelpers('Warehouse')

  export default {
    name: 'warehouse-details',

    computed: {
      ...mapState(['fetching', 'model']),
    },
  }
</script>
